

document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  const revealEls = document.querySelectorAll('.reveal, .reveal--left, .reveal--right, .reveal--scale');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(el => io.observe(el));
  }

  const ticker = document.querySelector('.usp-strip__track');
  if (ticker) {
    ticker.innerHTML += ticker.innerHTML;
  }

  const quoteTrack = document.querySelector('.quote-track');
  if (quoteTrack) {
    quoteTrack.innerHTML += quoteTrack.innerHTML;
  }

  const statEls = document.querySelectorAll('.stat__value[data-target]');
  if (statEls.length) {
    const counterIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateCounter(e.target);
          counterIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    statEls.forEach(el => counterIO.observe(el));
  }

  function animateCounter(el) {
    const target = parseFloat(el.dataset.target);
    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    const decimals = el.dataset.decimals ? parseInt(el.dataset.decimals) : 0;
    const duration = 1800;
    const start = performance.now();
    const ease = t => 1 - Math.pow(1 - t, 4);

    requestAnimationFrame(function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const val = target * ease(progress);
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    });
  }

  const heroBg = document.querySelector('.hero__bg');
  if (heroBg && window.innerWidth > 768) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      heroBg.style.transform = `translateY(${y * 0.3}px)`;
    }, { passive: true });
  }

  const lifeTrack = document.querySelector('.lifestyle-strip__track');
  if (lifeTrack) {
    lifeTrack.innerHTML += lifeTrack.innerHTML;
  }

  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (!href || href === '#') return;
      let target = null;
      try { target = document.querySelector(href); } catch (_) {}
      if (target) {
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-cart-btn]');
      const feedback = form.querySelector('.cart-feedback');
      const variantId = form.querySelector('[name="id"]').value;
      if (!variantId) return;
      const planField = form.querySelector('[name="selling_plan"]');
      const sellingPlan = planField ? planField.value : '';

      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(
            sellingPlan
              ? { id: variantId, quantity: 1, selling_plan: sellingPlan }
              : { id: variantId, quantity: 1 }
          )
        });
        if (res.ok) {
          btn.textContent = 'Added to Cart';

          if (feedback) {
            feedback.innerHTML = '<span class="cart-feedback__msg">Added to your cart.</span>' +
              '<a class="cart-feedback__link" href="/cart">View cart &amp; checkout &rarr;</a>';
            feedback.classList.add('show');
            feedback.classList.remove('error');
          }

          try {
            const cart = await (await fetch('/cart.js')).json();
            document.querySelectorAll('[data-cart-count]').forEach(el => {
              el.textContent = cart.item_count;
              el.classList.toggle('is-filled', cart.item_count > 0);
            });
          } catch (_) {  }

          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          throw new Error('failed');
        }
      } catch (_) {
        btn.textContent = originalText;
        btn.disabled = false;
        if (feedback) { feedback.textContent = 'Something went wrong. Please try again.'; feedback.classList.add('show', 'error'); }
      }
    });
  });

  document.querySelectorAll('.variant-select').forEach(select => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const priceEl = form && form.querySelector('[data-variant-price]');
      const opt = select.options[select.selectedIndex];
      if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      const hiddenId = form && form.querySelector('[name="id"]');
      if (hiddenId) hiddenId.value = select.value;
    });
  });

  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.faq-item.open').forEach(open => {
        if (open !== item) {
          open.classList.remove('open');
          open.querySelector('.faq-answer').style.maxHeight = '0';
          const b = open.querySelector('.faq-question');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.toggle('open', !isOpen);
      answer.style.maxHeight = isOpen ? '0' : answer.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

});

(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var K = (window.GUMMAH || {}).klaviyo || {};
  window.gummahKlaviyo = {

    configured: function (listId) { return !!(K.key && (listId || K.list)); },
    subscribe: function (email, firstName, props, listId) {
      var lid = listId || K.list;
      var attrs = { email: email };
      if (firstName) attrs.first_name = firstName;
      if (props) attrs.properties = props;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: attrs } } },
            relationships: { list: { data: { type: 'list', id: lid } } }
          }
        })
      });
    }
  };

  function isNativeSignup(form) {
    if (!form || typeof form.querySelector !== 'function') return false;
    if (!form.querySelector('input[type="email"]')) return false;

    if (!form.querySelector('.hp-field')) return false;
    if (form.querySelector('textarea')) return false;
    return !(form.closest('[data-quiz-root]') || form.closest('.scratch-overlay'));
  }

  function markForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (isNativeSignup(forms[i])) forms[i].setAttribute('novalidate', 'novalidate');
    }
  }
  if (document.readyState !== 'loading') markForms();
  else document.addEventListener('DOMContentLoaded', markForms);

  function showError(form, email, msg, focusEl) {
    var box = form.querySelector('[data-waitlist-error], [data-sl-error], [data-signup-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-signup-error', '');
      box.style.cssText = 'color:#9a2f24;font-size:0.85rem;margin:0.5rem 0 0;';
      var anchor = (focusEl || email);
      if (anchor && anchor.parentNode) anchor.parentNode.appendChild(box);
      else form.appendChild(box);
    }
    box.hidden = false; box.style.display = 'block'; box.textContent = msg;
    if (focusEl) { try { focusEl.focus(); } catch (e) {} }
  }

  function showSuccess(form) {
    var card = form.closest('[data-signup-card], .email-form-card, .sl-card') || form.parentNode;
    var custom = card.querySelector(':scope > [data-signup-success]');
    var kids = card.children;
    for (var i = 0; i < kids.length; i++) { if (kids[i] !== custom) kids[i].style.display = 'none'; }
    if (custom) { custom.hidden = false; return; }
    var s = document.createElement('div');
    s.className = 'signup-success-js';
    s.innerHTML = '<div class="signup-success-js__title">You’re in.</div>' +
      '<p class="signup-success-js__body">You’re on the waitlist. Check your inbox for your 10% code; the Creatine Gummy Playbook comes with it as a bonus.</p>';
    card.appendChild(s);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isNativeSignup(form)) return;
    var email = form.querySelector('input[type="email"]');
    var hp = form.querySelector('.hp-field');
    var name = form.querySelector('input[name="contact[name]"], input[name="contact[first_name]"]');

    if (hp && hp.value) { e.preventDefault(); e.stopPropagation(); return; }
    if (name && name.value.trim().length < 2) { e.preventDefault(); e.stopPropagation(); return showError(form, email, 'Please enter your first name.', name); }
    if (!EMAIL_RE.test(email.value.trim())) { e.preventDefault(); e.stopPropagation(); return showError(form, email, 'Please enter a valid email address.', email); }

    var listEl = form.closest('[data-klaviyo-list]');
    var listId = listEl ? listEl.getAttribute('data-klaviyo-list') : '';
    var btn = form.querySelector('button[type="submit"], .form-submit-btn, .sl-submit');

    try {
      var last = parseInt(localStorage.getItem('gummah_last_submit') || '0', 10);
      if (Date.now() - last < 4000) { e.preventDefault(); e.stopPropagation(); return showError(form, email, 'One moment, that just went through.'); }
      localStorage.setItem('gummah_last_submit', String(Date.now()));
    } catch (x) {}

    if (window.gummahKlaviyo.configured(listId)) {
      e.preventDefault(); e.stopPropagation();
      if (btn) { btn.disabled = true; btn.dataset.lbl = btn.textContent; btn.textContent = 'Joining…'; }
      var props = { signup_source: 'waitlist' };
      var tagsEl = form.querySelector('input[name="contact[tags]"]');
      if (tagsEl && tagsEl.value) props.tags = tagsEl.value;
      var em = email.value.trim();
      var nm = name ? name.value.trim() : '';

      var subscribeOnce = function () {
        return window.gummahKlaviyo.subscribe(em, nm, props, listId)
          .then(function (r) { if (!r || !r.ok) throw new Error('klaviyo'); });
      };
      var postToShopify = function () {
        return fetch(form.getAttribute('action') || '/contact', {
          method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }
        });
      };

      subscribeOnce()
        .catch(subscribeOnce)
        .then(function () {

          try { postToShopify().catch(function () {}); } catch (x) {}
        }, function () {

          if (tagsEl && tagsEl.value.indexOf('klaviyo-failed') === -1) {
            tagsEl.value = tagsEl.value + ',klaviyo-failed';
          }
          return postToShopify().then(function (r) {

            if (!r.ok || (r.url && r.url.indexOf('/challenge') !== -1)) throw new Error('shopify');
          });
        })
        .then(function () {
          try { window.gummahTrack && window.gummahTrack.identify(em, nm); } catch (x) {}
          showSuccess(form);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.lbl || 'Join the Waitlist'; }
          showError(form, email, 'Something went wrong. Please try again.');
        });
    } else {

      if (btn) setTimeout(function () { btn.disabled = true; }, 0);
    }
  }, true);
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-plans]').forEach(group => {
    const form = group.closest('[data-add-to-cart]');
    if (!form) return;
    const planField = form.querySelector('[name="selling_plan"]');
    const buybox = group.closest('.pd-buybox') || document;
    const priceEl = buybox.querySelector('[data-variant-price]') || buybox.querySelector('.pd-price');

    group.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.matches('input[type="radio"]')) return;

      group.querySelectorAll('.pd-plan').forEach(l => l.classList.remove('is-selected'));
      const card = input.closest('.pd-plan');
      if (card) card.classList.add('is-selected');

      if (group.hasAttribute('data-variant-mode')) {
        var idField = form.querySelector('[name="id"]');
        if (idField && input.dataset.variantId) idField.value = input.dataset.variantId;
      } else if (planField) {
        planField.value = input.dataset.sellingPlan || '';
      }
      if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
    });
  });
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-copy-code]');
  if (!btn) return;
  const code = btn.dataset.copyCode;
  const flag = btn.querySelector('.quiz-reward__copy');
  try {
    await navigator.clipboard.writeText(code);
  } catch (_) {

    const t = document.createElement('textarea');
    t.value = code; t.setAttribute('readonly', '');
    t.style.position = 'absolute'; t.style.left = '-9999px';
    document.body.appendChild(t); t.select();
    try { document.execCommand('copy'); } catch (_) {}
    document.body.removeChild(t);
  }
  if (flag) {
    const original = flag.textContent;
    flag.textContent = 'Copied';
    btn.classList.add('is-copied');
    setTimeout(() => { flag.textContent = original; btn.classList.remove('is-copied'); }, 2000);
  }
});

(function () {
  var HEADER_GAP = 12;
  var DRIFT_TOLERANCE = 4;
  var MAX_HOLD_MS = 6000;

  function targetFor(hash) {
    if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return null;
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); }
    catch (e) { return null; }
  }

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function desiredY(el) {
    var y = el.getBoundingClientRect().top + scrollY() - HEADER_GAP;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.max(0, Math.min(y, max));
  }

  function hold(el) {
    var released = false;
    var teardown = [];
    var frame = null;

    function release() {
      if (released) return;
      released = true;
      if (frame) cancelAnimationFrame(frame);
      teardown.forEach(function (fn) { try { fn(); } catch (e) {} });
    }

    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, release, { passive: true });
      teardown.push(function () { window.removeEventListener(ev, release); });
    });

    function repin() {
      if (released || frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        if (released) return;
        var want = desiredY(el);
        if (Math.abs(scrollY() - want) > DRIFT_TOLERANCE) window.scrollTo(0, want);
      });
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(repin);
      try {
        ro.observe(document.body);
        teardown.push(function () { ro.disconnect(); });
      } catch (e) {}
    } else {

      var lastH = document.documentElement.scrollHeight;
      var iv = setInterval(function () {
        var h = document.documentElement.scrollHeight;
        if (h !== lastH) { lastH = h; repin(); }
      }, 100);
      teardown.push(function () { clearInterval(iv); });
    }

    var pending = 0;
    Array.prototype.slice.call(document.images).forEach(function (img) {
      if (img.complete) return;
      pending++;
      function onSettled() {
        img.removeEventListener('load', onSettled);
        img.removeEventListener('error', onSettled);
        pending--;
        repin();

        if (pending <= 0) setTimeout(release, 400);
      }
      img.addEventListener('load', onSettled);
      img.addEventListener('error', onSettled);
      teardown.push(function () {
        img.removeEventListener('load', onSettled);
        img.removeEventListener('error', onSettled);
      });
    });

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(repin)['catch'](function () {});
    }

    if (!pending) setTimeout(release, 1200);

    var ceiling = setTimeout(release, MAX_HOLD_MS);
    teardown.push(function () { clearTimeout(ceiling); });

    repin();
  }

  function goTo(el, smooth) {
    var y = desiredY(el);
    try { window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' }); }
    catch (e) { window.scrollTo(0, y); }
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var node = e.target;
    while (node && node.nodeType === 1 && node.tagName !== 'A') node = node.parentNode;
    if (!node || node.nodeType !== 1 || node.tagName !== 'A') return;

    var href = node.getAttribute('href') || '';
    var hash = '';
    if (href.charAt(0) === '#') hash = href;
    else if (href.indexOf('/#') === 0 && window.location.pathname === '/') hash = href.slice(1);
    if (!hash) return;

    var el = targetFor(hash);
    if (!el) return;

    e.preventDefault();
    goTo(el, true);
    try { if (window.history && history.replaceState) history.replaceState(null, '', hash); } catch (x) {}

    setTimeout(function () { hold(el); }, 420);
  });

  if (window.location.hash) {
    var initial = targetFor(window.location.hash);
    if (initial) {
      window.addEventListener('load', function () { goTo(initial, false); hold(initial); });
    }
  }
})();

(function () {
  var K = (window.GUMMAH || {}).klaviyo || {};
  if (!K.key) return;

  function consented() {
    try {
      var sp = window.Shopify && Shopify.customerPrivacy;
      if (sp && typeof sp.analyticsProcessingAllowed === 'function') {
        return sp.analyticsProcessingAllowed() || sp.marketingAllowed();
      }
    } catch (e) {}
    try { return localStorage.getItem('gummah_cookie_consent') === 'accepted'; } catch (e) {}
    return false;
  }

  var loaded = false;
  function load() {
    if (loaded || !consented()) return;
    if (document.querySelector('script[src*="static.klaviyo.com"]')) { loaded = true; return; }
    loaded = true;
    var t = document.createElement('script');
    t.async = true;
    t.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(K.key);
    document.head.appendChild(t);
  }

  window.gummahTrack = {
    ready: function () { return loaded; },
    load: load,
    identify: function (email, firstName) {
      if (!email) return;
      load();
      window._learnq = window._learnq || [];
      var attrs = { $email: email };
      if (firstName) attrs.$first_name = firstName;
      window._learnq.push(['identify', attrs]);
    }
  };

  load();
  document.addEventListener('click', function (e) {
    var n = e.target;
    while (n && n.nodeType === 1 && !n.hasAttribute('data-cookie-accept')) n = n.parentNode;
    if (n && n.nodeType === 1) setTimeout(load, 60);
  });
})();
